import React from "react";
import PropTypes from "prop-types";
import Header from "../common/Header.jsx";
import Footer from "../common/Footer.jsx";
import SettingsContainer from "./SettingsContainer";
import NotificationsPopup from "../common/NotificationsPopup";

const SettingsPage = ({ organizationId }) => (
    <div className="container">
        <div id="SettingsPage">
            <Header/>
            <SettingsContainer organizationId={organizationId}/>

            <Footer/>

            <NotificationsPopup />
        </div>
    </div>
);

SettingsPage.propTypes = {
    organizationId: PropTypes.number.isRequired
};

export default SettingsPage;
